import React from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";

const MissionControl = () => {
  return (
    <PageScaffold title="MC" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        <iframe
          src="https://garaaz.retool.com/apps/Mission%20Control"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Mission Control"
        />
      </Box>
    </PageScaffold>
  );
};

export default MissionControl;
